<template> <!-- -->
  <div class="padding-coluna">
    <div class="p-grid p-fluid" style="padding-bottom: 2%"  >
      <Panel header="Dados do vínculo" class="p-col-12" v-if="isPodeEditarDados">
        <div class="p-grid p-fluid" style="padding-bottom: 2%"  >
        <Rotulo nome="Tipo Vínculo:" cols="12 12">
          <Dropdown
            v-model="registro.tipoVinculo"
            :options="tiposVinculo"
            optionLabel="descTipoVinculo"
            placeholder="Selecione tipo de vínculo"
            :disabled = true
          />
        </Rotulo>
        <Rotulo nome="Entidade:" cols="12 6">
          <Dropdown 
            v-model="registro.orgao"
            :filter="true" 
            :options="orgaos"
            optionLabel="siglOrgao"
            placeholder="Selecione um Órgão / Empresa"
            @change='buscarUnidades()'
          />
        </Rotulo>
        <Rotulo nome="Unidade:" cols="12 6">
          <!--<Dropdown 
            v-model="registro.unidade"
            :filter="true" 
            :options="unidades"
            optionLabel="descricaoCompleta"
            placeholder="Selecione uma Unidade"
            
          />-->
          <Dropdown 
            v-model="registro.unidade"
            :filter="true" 
            :options="unidades"
            optionLabel="descUnidade"
            placeholder="Selecione uma Unidade"
            dataKey="idenUnidade"
          />
        </Rotulo>
        <Rotulo nome="Cargo:" cols="12 12">
          <Dropdown 
            v-model="registro.cargo"
            :filter="true" 
            :options="cargos"
            optionLabel="descSeapCompleta"
            placeholder="Selecione um Cargo"
            
          />
        </Rotulo>
        
        </div>
        <div class="p-col-12 p-md-4" style="float:right">
        <br>
        <Button
          label="Salvar"
          class="p-button-success"
          icon="pi pi-check"
          style="margin-top:1rem"
          @click="salvarVinculo()" 
          :disabled="registro.tipoVinculo==null && registro.orgao == null &&  registro.cargo == null"
          
        />
      </div>
      </Panel>
      <Panel header="Vínculos do usuário" class="p-col-12">
        <div class="p-col-12">
        
          <DataTable :value="cDadosVinculos" selectionMode="single" responsiveLayout="scroll" :selection.sync="vinculoSelecionado" editMode="row" dataKey="idenVinculo" :editingRows.sync="editingRows" @row-edit-save="onRowEditSave" @row-edit-init="onRowEditInit" @row-edit-cancel="onRowEditCancel">
            <Column field="numrVinculo" header="Nº"></Column>
            <Column field="orgao.descOrgao" header="Órgão" >
              <template #editor="slotProps">
                <Dropdown v-if="slotProps.data.tipoVinculo.nomeRole=='EXTERNO'"
                  v-model="slotProps.data.orgao"
                  :filter="true" 
                  :options="orgaos"
                  optionLabel="siglOrgao"
                  placeholder="Selecione um Órgão / Empresa"
                  @change='buscarUnidades(slotProps.data.orgao)'
                />
                <label v-else-if="slotProps.data.orgao!=null">{{slotProps.data.orgao.descOrgao}}</label>
              </template>
            </Column>
            <Column field="unidade.descUnidade" header="Unidade">
             
              <template #editor="slotProps" >
                <!--<Dropdown  v-if="slotProps.data.tipoVinculo.nomeRole=='EXTERNO'"
                  v-model="slotProps.data.unidade"
                  :filter="true" 
                  :options="unidades"
                  dataKey="unidade.idenUnidade"
                  optionLabel="descricaoCompleta"
                  placeholder="Selecione uma Unidade"
                />-->

                <Dropdown  v-if="slotProps.data.tipoVinculo.nomeRole=='EXTERNO'"
                  v-model="slotProps.data.unidade"
                  :filter="true" 
                  :options="unidades"
                  dataKey="idenUnidade"
                  optionLabel="descUnidade"
                  placeholder="Selecione uma Unidade"
                />
                <label v-else-if="slotProps.data.unidade!=null">{{slotProps.data.unidade.descUnidade}}</label>
              </template>
            </Column>
            <Column field="cargo.descSeap" header="Categoria">
              <template #editor="slotProps" >
                <Dropdown v-if="slotProps.data.tipoVinculo.nomeRole=='EXTERNO'"
                  v-model="slotProps.data.cargo"
                  :filter="true" 
                  :options="cargos"
                  optionLabel="descSeapCompleta"
                  placeholder="Selecione um Cargo"
                  
                />
                <label v-else-if="slotProps.data.cargo!=null">{{slotProps.data.cargo.descSeap}}</label>
              </template>
            </Column>
            <Column field="tipoVinculo.descTipoVinculo" header="Tipo"></Column>
            <Column field="statVinculo" header="Status"></Column>
            <Column :rowEditor="true" headerStyle="width:6em" bodyStyle="text-align:center"></Column>
          </DataTable>
        </div>
      
        <div class="p-col-12 p-md-4" v-if="perfis" style="float:right">
          <br>
          <Button
            label="Aplicar"
            class="p-button-success"
            icon="pi pi-check"
            style="margin-top:1rem"
            @click="alterarPerfil()"
            :disabled="perfilSelect==null || vinculosPerfilPessoaSelecionado.length == 0"
            
          />
        </div>
      </Panel>
    </div>  
  </div>
</template>
<script>
import { printToast } from "@/config/global";
import { baseApiUrl} from "@/config/global";
import Rotulo from "@/template/RotuloSeplag.vue";
const getVinculo = () => {
    return {
      idenVinculo: null,
      numrVinculo: null,
      descVinculo: null,
      pessoa: { idenPessoa: null },
      numrMatricula: null,
      descTipoVinculo: null,
      siglRegimeJur: null,
      /*orgao: {
        idenOrgao : null,
        descOrgao: null,
        siglOrgao: null,
      },*/
      orgao: null,
      /*unidade: {
        idenUnidade: null,
        codgSeap: null,
        descUnidade: null,
        descricaoCompleta: null,
        siglUnidade: null,
      },*/
      unidade : null,
      statVinculo : "ATIVO",
      descCategoria : null,
      descRegimeJur: null,
      siglTipoVinc: null,
      siglCategoria: null,
      /*cargo: {
        idenCargo : null,
        codgSeap : null,
        descSeap : null,
      },*/
      cargo : null,
      tipoVinculo: {
        idenTipoVinculo: 3,
        nomeRole: "EXTERNO",
        descTipoVinculo: "Externo"
      }
    };
  };
export default {
  name: 'usuario-vinculos',
  components: { Rotulo },
  props: {
   data:{
      type:Object,
      require: true
    },
    perfis: {
      type: Array,
      require: true
    },    
    dadosVinculos : {
      type: Array,
      require: true
    },  
  },
  data: function () {
    return {
      perfilSelect: null,
      isPodeEditarDados : false,
      vinculoSelecionado: [],
      cDadosVinculos_temp:[],
      tDadosVinculos : [],
      registro : getVinculo(),
      tiposVinculo : [],
      unidades : [],
      orgaos : [],
      cargos : [],
      idenPessoa : null,
      camposTabela: [
        { titulo: "Perfil de Acesso", nome: "perfilAcesso.nomePerfilAcesso"},
        { titulo: "Sistema", nome:"perfilAcesso.sistema.nomeSistema"},
      ],
      editingRows: [],
      originalRows: {},
    };
  },
  computed: {
      cDadosVinculos: {
        get: function() {
          return this.dadosVinculos
        },
        set: function(val) {
          this.$emit('atualizarDadosVinculo', val)
        }
      }
    },
  methods: {
    async carregarDadosVinculos(){
      this.isPodeEditarDados =  this._props.data.pessoa.flagOrigem == 'DECLARACAOBENS';
      this.idenPessoa = this._props.data.pessoa.idenPessoa
      this.registro.pessoa.idenPessoa = this.idenPessoa
      
      await this.$http.get(`${baseApiUrl}/tipovinculos/all`).then((res) => {
        this.tiposVinculo = res.data;
      });
      await this.$http.get(`${baseApiUrl}/orgaos/naoextintos`).then((res) => {
        this.orgaos = res.data;
      });
      await this.$http.get(`${baseApiUrl}/cargos`).then((res) => {
        this.cargos = res.data;
      });

      
    },
    buscarUnidades(p_orgao){

      let v_orgao = p_orgao ? p_orgao : this.registro.orgao

      this.$http.get(`${baseApiUrl}/unidades/orgao/${v_orgao.idenOrgao}`).then((res) => {
        this.unidades = res.data;
      });

      /*this.$http.get(`${baseApiUrl}/unidades/organograma/${v_orgao.idenOrgao}`).then((res) => {
        this.unidades = res.data;
      });*/

     
    },
    onRowSelect(event) {
        this.$toast.add({severity: 'info', summary: 'Car Selected', detail: 'Vin: ' + event.data.vinculo.idenVinculo, life: 3000});
    },
    onRowUnselect(event) {
        this.$toast.add({severity: 'warn', summary: 'Car Unselected', detail: 'Vin: ' + event.data.vinculo.idenVinculo, life: 3000});
    },
    
    salvarVinculo(){
      //this.registro.numrVinculo = this.vinculosPerfilPessoa==null ? 1 : Object.keys(this.vinculosPerfilPessoa).length + 1
      this.registro.numrVinculo = this.cDadosVinculos.length + 1
      this.registro.numrMatricula = this._props.data.pessoa.numrCpf.replaceAll(".","").replaceAll("-","")
      this.$http
      .post(`${baseApiUrl}/vinculos`, JSON.stringify(this.registro))
      .then(() => { 
          
        printToast({severity: 'success', summary: 'Sucesso', detail: 'Vínculo salvo com sucesso'})              
        this.$http.get(`${baseApiUrl}/vinculos/pessoa/${this.idenPessoa}`).then((res) => {
          let cDadosVinculos_temp = res.data;
          this.tDadosVinculos = []
          cDadosVinculos_temp.forEach(vinc => {
            vinc.perfil = []
            this.$http.get(`${baseApiUrl}/seguranca/perfilacessos/vinculo/${vinc.idenVinculo}`).then((res) => {
              vinc.perfil = res.data;
            }); 
            this.tDadosVinculos.push(vinc)
          })
          this.cDadosVinculos = this.tDadosVinculos
        }); 
        this.carregarDadosVinculos()
          
      });
    },

    onRowEditInit(event) {

      if(this.cDadosVinculos[event.index].tipoVinculo.nomeRole == 'EXTERNO') {
        if(this.cDadosVinculos[event.index].orgao!=null){
          this.buscarUnidades(this.cDadosVinculos[event.index].orgao)
        }
        this.originalRows[event.index] = {...this.cDadosVinculos[event.index]};
      } else {
        this.onRowEditCancel()
      }
    },
    onRowEditCancel() {
        this.originalRows = {};
    },
    onRowEditSave(event){

      if(this.cDadosVinculos[event.index].tipoVinculo.nomeRole=='EXTERNO') {
        let dadosVinculo = {...this.cDadosVinculos[event.index]}


        this.$http.put(`${baseApiUrl}/vinculos/${this.cDadosVinculos[event.index].idenVinculo}`,JSON.stringify(dadosVinculo)).then(()=>{
            this.$toast.add({severity:'success', summary: 'Ação Efetuada', detail:"Vínculo alterado com Sucesso", life: 5000});  
        })
      } 
    },
    
  },
  
  mounted() {
    this.carregarDadosVinculos();
  }
};

</script>
<style scoped>
    .hr-modal{            
        border: 0;
        height: 0;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        border-bottom: 1px solid rgba(255, 255, 255, 0.3);
        width:100%;
        margin-bottom: 0.7%;
        margin-top: 0.7%;
    }
  
    .estilo-card>.div{
        border-radius: 25px;

    }
 
    @media screen and (max-width: 40em) {
        .padding-coluna{
            padding: 0 !important;
        }            
    }

    .voltar{
        width: auto;
        margin: 0.9rem 0;
    }

    .descricao{
        margin-bottom: 1.5%;
    }
</style>